import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import monsterTypes from '../../data/monsterTypes'
import { translationsMapping } from '../../../config'

const MonsterTypeName = ({ id, language, settings }) => {
	const appliedLanguage = settings['app.cardNameLanguage'] || translationsMapping[language]

	return monsterTypes[id][`name_${appliedLanguage}`]
}

MonsterTypeName.propTypes = {
	id: PropTypes.number.isRequired,
	language: PropTypes.string.isRequired,
	settings: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
	language: state.persist.language,
	settings: state.persist.user.settings
})

const enhance = connect(mapStateToProps)

export default enhance(MonsterTypeName)
